module.exports = __webpack_public_path__ + "static/media/success.97d56ac3.png";